import * as a from '../actions'
import { boughtPrizeEvent, newTitleEvent, newLvlEvent, newMedalEvent } from '../utils/constants'

export const initialState = []

const newEvents = ({ lvlup, new_medals, new_titles }) => {
  const new_events = []
  if (new_titles && new_titles.length > 0) {
    new_titles.forEach(t => new_events.push(newTitleEvent(t)))
  }
  if (lvlup) {
    new_events.push(newLvlEvent(lvlup))
  }
  if (new_medals && new_medals.length > 0) {
    new_medals.forEach(m => new_events.push(newMedalEvent(m)))
  }
  return new_events
}

const userEventUpdate = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case a.NEW_EVENTS_FETCH_SUCCEEDED:
      return state.concat(newEvents(payload))
    case a.BUY_PRIZE_SUCCEEDED:
      return state.concat(boughtPrizeEvent(payload))
    case a.EVENT_ALERT_SHOWED:
      return state.slice(1)
    default:
      return state
  }
}

export default userEventUpdate



// WEBPACK FOOTER //
// ./src/reducers/user_events.jsx